const getUnidadesExaustor = () => {
    const url = `${process.env.REACT_APP_SERVER_IP}/exaustor`;
    return fetch(url)
        .then(response => response.json())
        .then(data => {
            console.log(data);
            return data; // Retorna os dados diretamente
        })
        .catch(error => {
            console.error("Erro na requisição HTTP GET:", error);
            return []; // Retorna um array vazio em caso de erro
        });
};

export default getUnidadesExaustor;